export enum ResourceType {
  ARTICLE = 'ARTICLE',
  COMMENT = 'COMMENT',
  USER = 'USER'
}

export enum ModerationType {
  SEXUAL = 'SEXUAL',
  SEXUAL_MINORS = 'SEXUAL_MINORS',
  HARASSMENT = 'HARASSMENT',
  HARASSMENT_THREATENING = 'HARASSMENT_THREATENING',
  HATE = 'HATE',
  HATE_THREATENING = 'HATE_THREATENING',
  ILLICIT = 'ILLICIT',
  ILLICIT_VIOLENT = 'ILLICIT_VIOLENT',
  SELF_HARM = 'SELF_HARM',
  SELF_HARM_INTENT = 'SELF_HARM_INTENT',
  SELF_HARM_INSTRUCTIONS = 'SELF_HARM_INSTRUCTIONS',
  VIOLENCE = 'VIOLENCE',
  VIOLENCE_GRAPHIC = 'VIOLENCE_GRAPHIC',
  NONE = 'NONE'
}

// Additional types for API responses
export interface ViolationType {
  type: ModerationType;
  description: string;
}

export interface ReportResponse {
  success: boolean;
  message: string;
  data: null;
}

// Update the CreateReportDTO to use these types
export interface CreateReportDTO {
  targetId: string;
  targetType: ResourceType;
  violations: ModerationType[];
  detail?: string;
}
